import TermsOfUseLinks from './TermsOfUseLinks';

export default TermsOfUseLinks;
